import React from "react";
import Chip from "@material-ui/core/Chip";
import {makeStyles} from "@material-ui/core/styles";
import {useFormikContext} from "formik";
import {Col, Row} from "react-bootstrap";
import {useSelector} from "react-redux";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
        minHeight: 50
    },
    chip: {
        margin: theme.spacing(0.5),
    },
}));

export const StudentsSelection = ({metaSection = 'groups', name = 'students', placeholder = "Studenti nel gruppo"}) => {

    const {values, setFieldValue} = useFormikContext();

    const students = useSelector(state => state?.[metaSection]?.meta?.students ?? []);

    const groupStudents = values[name] ?? []

    const classes = useStyles();
    return <Row>
        <Col md={12}>
            <FormControl fullWidth>
                <Autocomplete
                    multiple
                    id="fixed-tags-demo"
                    value={groupStudents}
                    onChange={(event, newValue) => {
                        setFieldValue(name, newValue);
                    }}
                    disableCloseOnSelect
                    options={students.filter(el => groupStudents.map(el => el.id).indexOf(el.id) < 0)}
                    getOptionLabel={(option) => option.name}
                    renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                            <Chip
                                className={classes.chip}
                                label={option.name}
                                onDelete={() => {
                                    const newVal = [
                                        ...groupStudents.slice(0, groupStudents.indexOf(option)),
                                        ...groupStudents.slice(groupStudents.indexOf(option) + 1),
                                    ];

                                    setFieldValue(name, newVal);
                                }}
                            />
                        ))
                    }
                    renderInput={(params) => (
                        <TextField {...params} variant={"outlined"} label={placeholder}/>
                    )}
                />
            </FormControl>
        </Col>
    </Row>
}
